import React, { Component } from 'react';

export default class Logout extends Component {

	constructor(props) {
    super(props);
  	this.state = { authorized: false };
  }
	componentWillMount() {
		console.log('checking if the user is logged in', this.props);
		this.props.onStatusChange(false);
	}
	render() {
		console.log('Logout render', this.state);
		return (
			<div id="auth">
				<h1>You are logged out</h1>
				<p>You are not logged in.</p>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/logout.jsx